import { Home, Key, Briefcase, Building2 } from "lucide-react";
import { useReveal } from "../../lib/animations";

const audiences = [
  {
    icon: Home,
    title: "Huiseigenaars",
    desc: "Renovatie, verbouwing of herstellingen? Weet voor je tekent of de prijs klopt.",
  },
  {
    icon: Key,
    title: "Huurders",
    desc: "Ontvang je facturen voor herstellingen? Check of je verhuurder je niet overvraagt.",
  },
  {
    icon: Briefcase,
    title: "KMO's en ondernemers",
    desc: "Vergelijk offertes voor IT, onderhoud of verbouwingen snel en objectief.",
  },
  {
    icon: Building2,
    title: "Vastgoedprofessionals",
    desc: "Bied je klanten extra service door offertes professioneel te laten valideren.",
  },
];

export default function Audiences() {
  const ref = useReveal();
  return (
    <section data-testid="audiences" className="oc-section bg-oc-bg">
      <div ref={ref} className="oc-reveal oc-container">
        <div className="max-w-5xl">
          <span className="text-[13px] uppercase tracking-[0.1em] font-semibold text-oc-secondary">
            Voor wie
          </span>
          <h2 className="font-display font-bold text-[28px] sm:text-[36px] lg:text-[42px] leading-tight tracking-tight text-oc-primary mt-3 whitespace-normal lg:whitespace-nowrap">
            Voor wie is OfferteExpert?
          </h2>
        </div>

        <div className="mt-14 grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {audiences.map((a, i) => {
            const Icon = a.icon;
            return (
              <div
                key={i}
                className="group bg-white rounded-oc border border-oc-border p-8 transition-all duration-300 hover:-translate-y-1 hover:shadow-oc-card-hover hover:border-oc-secondary/30"
                style={{ animation: `fade-in-up 600ms ease-out both ${i * 80}ms` }}
              >
                <div className="w-12 h-12 rounded-xl bg-oc-subtle flex items-center justify-center group-hover:bg-oc-primary group-hover:text-white transition-colors">
                  <Icon className="w-5 h-5" strokeWidth={2} />
                </div>
                <h3 className="font-display font-semibold text-[19px] text-oc-primary mt-6 leading-snug">
                  {a.title}
                </h3>
                <p className="mt-2 text-oc-textSecondary text-[15px] leading-relaxed">{a.desc}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
